var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.26 234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272b2e;}.cls-2{fill:#373c3f;}.cls-3{fill:#ced8dd;}.cls-4{fill:#fafeff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cl\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_6",
    "data-name": "Calque 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "204.34 168.74 58.28 159.38 226.75 46.8 299.26 33.62 204.34 168.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "194.45 127.22 48.39 117.85 216.86 5.27 291.08 0.14 194.45 127.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.12 117.99 58.01 159.51 204.34 168.74 299.26 33.62 291.35 0 194.45 127.22 48.12 117.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.47 133.81 108.1 148.31 200.38 152.92 266.96 66.58 261.69 53.39 197.09 139.08 105.47 133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "109.42 135.79 0 226.75 0 234 23.07 234 130.51 142.38 130.51 135.79 109.42 135.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 226.75 21.75 226.09 128.03 135.79 130.51 135.79 130.51 137.48 21.75 228.73 0 228.73 0 226.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1375.88,858.46l-.07-7.54h0a4.76,4.76,0,0,0-.07-1,1.42,1.42,0,0,0,0-.22c-1-4.16-7.71-6.07-14.91-4.27s-12.28,6.89-11.24,11c0,.08,0-.08,0,0h0l0,6.31h0a4.85,4.85,0,0,0,.11,1.32c1,4.16,7.72,6.07,14.91,4.27,6.7-1.67,11.49-6,11.28-9.91Z",
    transform: "translate(-1190 -753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1349.52,856.49s1.31,2,5.27,2c4.61,0,13.84.66,21.09-8.56l-.07,1.39s-3.22,6.52-12.45,7.83c-7.3,1-9.23.66-11.87,0a3.14,3.14,0,0,1-2-1.31Z",
    transform: "translate(-1190 -753)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCle);
export default __webpack_public_path__ + "static/media/cle.16628578db31cefb30b6484773d80d50.svg";
export { ForwardRef as ReactComponent };